import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

export const physicalPrepaidCardDownload = http.post(
  createMockEndpoint('/physical_prepaid_card/download'),
  async () => {
    await delay(500);
    return HttpResponse.json(null, { status: 200 });
  },
);
